import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["style", "disabled", "distance", "throttleInterval", "children", "onLoadMore", "onScrollTopChange", "showLoading", "onTouchEnd"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useRef, useState } from 'react';
import { View, ScrollView } from 'react-native';
import { ListLoader } from '../../Loader/rn';
var THROTTLE_INTERVAL = 200;
export var InfiniteScroll = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var style = props.style,
    disabled = props.disabled,
    _props$distance = props.distance,
    distance = _props$distance === void 0 ? 100 : _props$distance,
    _props$throttleInterv = props.throttleInterval,
    throttleInterval = _props$throttleInterv === void 0 ? THROTTLE_INTERVAL : _props$throttleInterv,
    children = props.children,
    onLoadMore = props.onLoadMore,
    onScrollTopChange = props.onScrollTopChange,
    _props$showLoading = props.showLoading,
    showLoading = _props$showLoading === void 0 ? false : _props$showLoading,
    _props$onTouchEnd = props.onTouchEnd,
    _onTouchEnd = _props$onTouchEnd === void 0 ? function () {} : _props$onTouchEnd,
    other = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var scrollViewRef = useRef(null);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isTouchMove = _useState4[0],
    setIsTouchMove = _useState4[1];
  var handleScroll = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var contentOffset, nearBottom;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              contentOffset = event.nativeEvent.contentOffset;
              onScrollTopChange === null || onScrollTopChange === void 0 ? void 0 : onScrollTopChange(contentOffset.y);
              if (!loading) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              nearBottom = event.nativeEvent.contentSize.height - event.nativeEvent.contentOffset.y - event.nativeEvent.layoutMeasurement.height <= distance;
              if (!nearBottom) {
                _context.next = 10;
                break;
              }
              setLoading(true);
              _context.next = 9;
              return onLoadMore();
            case 9:
              setLoading(false);
            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleScroll(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var scrollTo = function scrollTo(scrollTop) {
    var _scrollViewRef$curren, _scrollViewRef$curren2;
    (_scrollViewRef$curren = scrollViewRef.current) === null || _scrollViewRef$curren === void 0 ? void 0 : (_scrollViewRef$curren2 = _scrollViewRef$curren.scrollTo) === null || _scrollViewRef$curren2 === void 0 ? void 0 : _scrollViewRef$curren2.call(_scrollViewRef$curren, {
      y: scrollTop,
      animated: false
    });
  };
  React.useImperativeHandle(ref, function () {
    return {
      scrollTo: scrollTo
    };
  });
  var Loading = /*#__PURE__*/React.createElement(View, {
    style: {
      alignItems: 'center',
      paddingVertical: 12
    }
  }, /*#__PURE__*/React.createElement(ListLoader, null));
  return /*#__PURE__*/React.createElement(ScrollView, _extends({
    style: {
      flex: 1
    },
    contentContainerStyle: style,
    role: "feed",
    onScroll: !disabled ? handleScroll : undefined,
    scrollEventThrottle: throttleInterval,
    ref: scrollViewRef,
    onTouchMove: function onTouchMove() {
      setIsTouchMove(true);
    },
    onTouchEnd: function onTouchEnd() {
      isTouchMove && (_onTouchEnd === null || _onTouchEnd === void 0 ? void 0 : _onTouchEnd());
      setIsTouchMove(false);
    }
  }, other), children, showLoading && loading && Loading);
});